<template>
  <transition name="fade">
      <div class="modal-mask" v-show="showModal"  @click.self="closeModal">
          <div class="message-box" :class="{ show: showModal }">
              <h2 class="message-title">视野分析说明</h2>
              <div class="message-content">
                <p class="bold">
                  视野计算逻辑：
                </p>
                <p>
                  当前版本以当前位置为中心，以150m为半径，120度为视野角度，计算水平视野范围。
                </p>
                <img style="width: 100%;" src="/images/fieldView.png" alt="">

              </div>
              <button class="close-btn" @click="closeModal">了解了</button>
          </div>
      </div>
  </transition>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
      // this.showModal = false;
    }
  },
}
</script>

<style scoped>
  /* 蒙版样式 */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* 确保足够高的z-index */
    transition: opacity 0.3s;
  }
  /* 消息框样式 */
  .message-box {
    background: white;
    width: 80%;
    height: 50%;
    /* max-width: 450px; */
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
    transform: scale(0.7);
    transition: all 1s ease;
    color: #333;
  }
  
  .message-box.show {
    transform: scale(1);
  }

  .message-title {
    height: 10%;
    font-size: 1.8rem;
    margin: 10px;
    color: #2575fc;
    font-weight: 600;
  }
  
  .message-content {
    width: 100%;
    height: 70%;
    font-size: 1.1rem;
    line-height: 1.6;
    margin-bottom: 25px;
    color: #555;
    overflow-y: auto;
  }

  .message-content p {
    text-align: left;
  }

  .close-btn {
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    color: white;
    border: none;
    padding: 12px 30px;
    font-size: 1.1rem;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
  }

  .close-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(37, 117, 252, 0.4);
  }
  /* 动画效果 */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }
  
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .bold{
    font-weight: bold;
  }
</style>